import React from "react";

export const Book = ({ title, largeImage, smallImage, langtext }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        <div className="hover-text">
          <h4>{title}</h4>
          <p>{langtext}</p>
        </div>
        <img src={smallImage} className="img-responsive" alt={title} />
      </div>
    </div>
  );
};
